module.exports = __webpack_public_path__ + "static/media/lct3.c7525543.png";